import React, { Component } from 'react';
import $ from 'jquery'

function getmail(mailcontent){
  $.ajax({
        dataType: "json",
        contentType: "application/json",
        type : "POST",
        url: `https://api.elasticemail.com/v2/email/send?subject=${mailcontent[0]}&from=hadrienallemon@gmail.com&fromName=${mailcontent[1]}&to=hadrienallemon@gmail.com&bodyHtml=<h3>${mailcontent[2]}</h3><br/><h2>${mailcontent[3]}</h2>&bodyText=Text Body&apikey=37ff539f-7cc0-4bdf-92bc-8e21773d7cc2&isTransactional=true`,
        //https://api.elasticemail.com/v2/email/send?apikey=37ff539f-7cc0-4bdf-92bc-8e21773d7cc2&subject=%27hey%27&from=hadrienallemon@gmail.com&fromName=%27None%27&to=%27hadrienallemon@gmail.com%27&bodyHtml=%3Cp%3Ebrowsertest%3C/p%3E&bodyText=%27Text%20Body%27&isTransactional=true
})
  .done(function(quote){
    console.log(quote)
  })
  .fail(function(error){console.log(error)});
}


function defocus(){
  $('.wrap').each((i,val)=>{
      if ($(val).find('input').val()===""){
        $(val).find('label').removeClass('fill');
      }
      if ($(val).find('textarea').val()===''){
        $(val).find('label').removeClass('fill');
      }
  })
}



$(document).on('click',defocus)


class ContactWrapper extends Component{
  constructor(props){
    super(props);
    this.state={
      name:'',
      subj:'',
      mail:'',
      contactbody:'',
      submit:''
    }
    this.handleChange=this.handleChange.bind(this);
    this.handleSubmit=this.handleSubmit.bind(this);
  }

  componentDidMount(){
    let $hr = $('.endstop hr')
    function toscroll(){
      $(window).scroll(()=>{
        if (($hr.offset().top)*1.25<(window.scrollY + window.innerHeight)){
          $hr.addClass('extend');
        }
      })
    }
    window.addEventListener('scroll',toscroll)
  }

  componentWillUnmount(){
    let $hr = $('.endstop hr')
    function toscroll(){
      $(window).scroll(()=>{
        if (($hr.offset().top)*1.25<(window.scrollY + window.innerHeight)){
          $hr.addClass('extend');
        }
      })
    }
    window.removeEventListener('scroll',toscroll)
    document.getElementById('mail').addEventListener('click',()=>{console.log('yes');window.open('mailto:hadrienallemon@gmail.com')})
  }

  handleClick(event){
    $(event.target).parent().find('label').addClass('fill');
  }

  handleChange(event){
    this.setState({
      [event.target.name]:event.target.value
    });
  }
  handleSubmit(event){
    this.setState({
      name:'',
      subj:'',
      mail:'',
      contactbody:'',
      submit:[this.state.subj,this.state.name,this.state.mail,this.state.contactbody]
    },
    function(){console.log('sent');getmail(this.state.submit)}
  )
}
  render(){
    return(
      <div className='endstop' >
        <h1>Contact me !</h1>
        <hr/>
        <div className='contactWrapper' id='contactform'>
          <form action="https://formspree.io/hadrienallemon@gmail.com" method="POST" >
            <div id='namewrap' className='wrap' >
              <label htmlFor='name' id='lname'>Name</label>
              <input onFocus={this.handleClick} onBlur={defocus} onChange={this.handleChange} type='text' name='name' id='name' value={this.state.name} onClick={this.handleClick}/><br/>
            </div>
            <div id='subjectwrap' className='wrap' >
              <label htmlFor='subject' id='lsubject'>Subject:</label>
              <input onFocus={this.handleClick} onBlur={defocus} onChange={this.handleChange} type='text' name='subj' id='subject' value={this.state.subj} onClick={this.handleClick}/><br/>
            </div>
            <div id='mailwrap' className='wrap' >
              <label htmlFor='backmail' id='lbackmail'>Mail to contact you back</label>
              <input onFocus={this.handleClick} onBlur={defocus} onChange={this.handleChange} type='text' name='mail' id='backmail' value={this.state.mail} onClick={this.handleClick}/><br/>
            </div>
            <div id='textwrap' className='wrap'>
              <label htmlFor='contactbody' id='lcontactbody'>Details</label>
              <textarea onFocus={this.handleClick} onBlur={defocus} onClick={this.handleClick} onChange={this.handleChange} value={this.state.contactbody} rows='8' cols='50' name='contactbody'  form='contactform'/>
            </div>
          </form>
          <button onClick={this.handleSubmit} type="submit">Submit !</button>
          <p>Or <span style={{cursor:'pointer'}} onClick={()=>{window.open('mailto:hadrienallemon@gmail.com')}} id='mail'><u>mail me</u></span> for any additional informations.</p>
        </div>
        <footer style={{float:'right',marginRight:'25px',color:'#B8B8B8'}}> Portfolio - Hadrien Allemon - 2018 - hadrienallemon@gmail.com</footer>
      </div>
    )
  }
}

export default ContactWrapper



// WEBPACK FOOTER //
// ./src/components/contactwrapper.js